import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
import { MatToolbar } from '@angular/material/toolbar';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.css'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatToolbar],
})
export class FooterComponent implements OnInit {
	private configService = inject(ConfigService);

	version?: string;

	ngOnInit(): void {
		this.version = this.configService.getVersion();
	}
}
